import(/* webpackMode: "eager" */ "/Users/green/Code/_worktrees/aideco-deploy-1022/apps/web/src/app/global-error.tsx");
